import openPreviewPlaylist from './openPreviewPlaylist';

const openSharePlaylist = (playlistId: number) => {
  openPreviewPlaylist({
    playlistId,
    shareOnMount: true,
  });
};
export default openSharePlaylist;
